import * as React from 'react';
import { t } from '../../../../services/HelperService';
import {
  CardHeader,
  Chip,
  ChipRow,
  FileNotesButton,
  MetaRow,
  money,
  shortDate,
  translateKey,
} from './builtInCardParts';

export const OpportunityBuiltInCard = ({ card, data }) => {
  return (
    <div>
      <CardHeader
        title={data.ContactName || data.CompanyName || card.description}
        repName={data.RepName}
        subTitle={data.Description ? (
          <div style={{ fontSize: 12, color: '#6c757d', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {data.Description}
          </div>
        ) : null}
      />
      <ChipRow>
        {data.ConfidenceLevel && <Chip tone="purple">{data.ConfidenceLevel}</Chip>}
        {data.PipelineStage && <Chip tone="blue">{translateKey(data.PipelineStage)}</Chip>}
        {data.LeadSource && <Chip tone="gray">{data.LeadSource}</Chip>}
      </ChipRow>
      {(data.ProductsOfInterest ?? []).length > 0 && (
        <ChipRow>
          {data.ProductsOfInterest.map(p => (
            <Chip key={p.Name} tone="green" title={p.Name}>
              {p.Name}{p.Count > 0 ? ` (${p.Count})` : ''}
            </Chip>
          ))}
        </ChipRow>
      )}
      <MetaRow icon="event" right={money(data.ExpectedRevenue)}>
        {data.ExpectedCloseDate
          ? `${t('Expected close')} ${shortDate(data.ExpectedCloseDate)}`
          : `${t('Lead')} ${shortDate(data.LeadDate)}`}
      </MetaRow>
      {(data.Suburb || data.CompanyName) && (
        <MetaRow icon="place">
          {[data.Suburb, data.ContactName && data.CompanyName ? data.CompanyName : ''].filter(Boolean).join(' · ')}
        </MetaRow>
      )}
      <FileNotesButton
        entityId={card.entityId}
        isOpportunity
        count={data.FileNoteCount}
      />
    </div>
  );
};
